document.addEventListener('DOMContentLoaded', () => {

  const slider = document.querySelector('.products-carousel');
  if (!slider) return;

  const cards = slider.querySelectorAll('.luxury-product-card');
  const next = document.querySelector('.next-btn');
  const prev = document.querySelector('.prev-btn');

  function getCardWidth() {
    if (!cards.length) return 0;
    const gap = parseInt(getComputedStyle(slider).columnGap || getComputedStyle(slider).gap) || 0;
    return cards[0].offsetWidth + gap;
  }

  next?.addEventListener('click', () => {
    slider.scrollBy({
      left: getCardWidth(),
      behavior: 'smooth'
    });
  });

  prev?.addEventListener('click', () => {
    slider.scrollBy({
      left: -getCardWidth(),
      behavior: 'smooth'
    });
  });

});